import React from "react";
import PropTypes from "prop-types";
import LogsSourceWidgetTableRow from "./LogsSourceWidgetTableRow";
import LogsSourceWidgetTableRowShowMore from "./LogsSourceWidgetTableRowShowMore";
import translate from "react-i18next/dist/commonjs/translate";

const LogsSourceStatusWidgetTable = ({ deviceGroups, t }) => {
  return (
    <table className="table table-responsive table-hover">
      <thead>
        <tr>
          <th className="col-xs-6">{t("logsSourceStatusWidgetTableType")}</th>
          <th className="col-xs-4">{t("logsSourceStatusWidgetTableStatus")}</th>
        </tr>
      </thead>
      <tbody>
        {deviceGroups.map((i, k) => {
          if (k < 6) {
            return (
              <LogsSourceWidgetTableRow deviceGroup={i} key={k} rowKey={k} />
            );
          }
        })}
        {deviceGroups.length > 6 && <LogsSourceWidgetTableRowShowMore />}
      </tbody>
    </table>
  );
};

LogsSourceStatusWidgetTable.propTypes = {
  deviceGroups: PropTypes.arrayOf(
    PropTypes.shape({
      numberOfDevices: PropTypes.number.isRequired,
      numberOfDevicesOnline: PropTypes.number.isRequired,
      isAllOnline: PropTypes.bool.isRequired,
      groupName: PropTypes.string.isRequired
    })
  ).isRequired
};

export default translate("translations")(LogsSourceStatusWidgetTable);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/LogsSourceStatusWidgetTable.js